import React, { useState } from 'react'
import { BusinessManagerStage } from '@marketing-milk/interfaces'
import Source from 'app/interface/data/funnel/source'
import { SaveTemplateDialog } from './SaveTemplateDialog'

export interface SaveTemplateButtonProps {
  stages: BusinessManagerStage[]
  sources: Source[]
}

/**
 * The single entry point for saving a funnel as a template. It lives in the
 * editor header rather than in a creation flow, because a template must be
 * savable from any business's funnel the user can open — otherwise the per-user
 * model only works for funnels you built from scratch.
 *
 * Bootstrap trigger, MUI dialog: the header row keeps one visual language,
 * while the dialog reuses the MUI form shape already proven inside this builder.
 */
export function SaveTemplateButton({ stages, sources }: SaveTemplateButtonProps) {
  const [open, setOpen] = useState(false)
  const disabled = stages.length === 0

  return (
    <>
      <button
        type="button"
        className="btn btn-brand"
        // branding.scss gives .btn-brand its own smaller padding, font size and
        // radius; put back the theme's .btn values so it matches its neighbours.
        style={{ padding: '.65rem 1rem', fontSize: '1rem', borderRadius: 0 }}
        disabled={disabled}
        title={disabled ? 'Add a stage first' : undefined}
        onClick={() => setOpen(true)}
      >
        Save as Template
      </button>
      <SaveTemplateDialog
        open={open}
        onClose={() => setOpen(false)}
        stages={stages}
        sources={sources}
      />
    </>
  )
}
